import { useState } from "react";
import { Button } from "@/components/ui/button";

const SubscribersList = ({ subscribers, loading, onRemove }) => {
  if (loading) return <p className="text-slate-400 text-center p-4">Loading...</p>;
  if (subscribers.length === 0) return <p className="text-slate-500 text-center py-8">No subscribers yet</p>;

  return (
    <div className="p-4">
      {subscribers.map((sub) => (
        <div key={sub.email} className="flex items-center justify-between py-2 border-b border-slate-800 last:border-0">
          <div>
            <span className="text-white text-sm">{sub.email}</span>
            <span className="text-slate-500 text-xs ml-2">
              {new Date(sub.subscribed_at).toLocaleDateString("en-GB")}
            </span>
          </div>
          <button onClick={() => onRemove(sub.email)} className="text-red-400 hover:text-red-300 text-xs px-2 py-1 rounded hover:bg-red-900/30 transition-colors">
            Remove
          </button>
        </div>
      ))}
    </div>
  );
};

const SubscribersToolbar = ({ view, subscriberCount, onEmailAll, onCopyAll, onClose }) => (
  <div className="flex gap-2">
    {view === "list" && subscriberCount > 0 && (
      <>
        <Button data-testid="email-all-button" onClick={onEmailAll} size="sm" className="bg-blue-600 hover:bg-blue-700 text-white">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
          Email All
        </Button>
        <Button data-testid="copy-all-emails" onClick={onCopyAll} variant="outline" size="sm" className="border-slate-600 text-slate-300 hover:bg-slate-800">
          Copy All
        </Button>
      </>
    )}
    <Button data-testid="close-subscribers-panel" onClick={onClose} variant="outline" size="sm" className="border-slate-600 text-slate-300 hover:bg-slate-800">
      Close
    </Button>
  </div>
);

export { SubscribersList, SubscribersToolbar };
